import { ACCESS_DOMAINS } from "@client";

export function checkBudgetTrackingQuery(
  projectId,
  pathName,
  companyId,
  userId,
) {
  return window.location.replace(
    ACCESS_DOMAINS.btApi +
    `check-budget-tracking?project_id=${projectId}&pathName=${pathName}&company_id=${companyId}&user_id=${userId}`
  );
}